import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// L'échelle de taille est CUSTOM (40/28/20/17/15/13/11) : sans cette
// déclaration, tailwind-merge ne reconnaît pas `text-h1` comme une taille et
// la laisse cohabiter avec le `text-base` d'un composant de base — la classe
// passée par l'appelant ne gagne alors jamais.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['display', 'h1', 'h2', 'h3', 'body', 'label'] },
      ],
    },
  },
});

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
